var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWomenEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.945,
    y2: 0.956,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606",
    transform: "translate(-1274 -408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605",
    transform: "translate(21 -565.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_67",
    "data-name": "Path 67",
    transform: "translate(1253 973.875)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28 1 C 24.35457992553711 1 20.81874084472656 1.713741302490234 17.49068832397461 3.121379852294922 C 14.27566909790039 4.481220245361328 11.38806915283203 6.42816162109375 8.908119201660156 8.908119201660156 C 6.42816162109375 11.38806915283203 4.481220245361328 14.27566909790039 3.121379852294922 17.49068832397461 C 1.713741302490234 20.81874084472656 1 24.35457992553711 1 28 C 1 31.64542007446289 1.713741302490234 35.18125915527344 3.121379852294922 38.50930786132812 C 4.481220245361328 41.72433090209961 6.42816162109375 44.61193084716797 8.908119201660156 47.09188079833984 C 11.38806915283203 49.57183837890625 14.27566909790039 51.51877975463867 17.49068832397461 52.87862014770508 C 20.81874084472656 54.28625869750977 24.35457992553711 55 28 55 C 31.64542007446289 55 35.18125915527344 54.28625869750977 38.50930786132812 52.87862014770508 C 41.72433090209961 51.51877975463867 44.61193084716797 49.57183837890625 47.09188079833984 47.09188079833984 C 49.57183837890625 44.61193084716797 51.51877975463867 41.72433090209961 52.87862014770508 38.50930786132812 C 54.28625869750977 35.18125915527344 55 31.64542007446289 55 28 C 55 24.35457992553711 54.28625869750977 20.81874084472656 52.87862014770508 17.49068832397461 C 51.51877975463867 14.27566909790039 49.57183837890625 11.38806915283203 47.09188079833984 8.908119201660156 C 44.61193084716797 6.42816162109375 41.72433090209961 4.481220245361328 38.50930786132812 3.121379852294922 C 35.18125915527344 1.713741302490234 31.64542007446289 1 28 1 M 28 0 C 43.46397018432617 0 56 12.53602981567383 56 28 C 56 43.46397018432617 43.46397018432617 56 28 56 C 12.53602981567383 56 0 43.46397018432617 0 28 C 0 12.53602981567383 12.53602981567383 0 28 0 Z",
    stroke: "none",
    fill: "#1fa4b6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1604",
    "data-name": "Group 1604",
    transform: "translate(949.919 188.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12506",
    "data-name": "Path 12506",
    d: "M361.124,257.112h1.15a1.631,1.631,0,0,1,1.468,1.007l.767,2.265c.188.556-.232,1.007-.937,1.007H341.384c-.705,0-1.125-.451-.936-1.007l.766-2.265a1.632,1.632,0,0,1,1.468-1.007h.484a.117.117,0,0,1,0-.013v-9.807a8.98,8.98,0,1,1,17.96,0v9.82Zm-4.007-9.426v0a.954.954,0,0,0,1.907-.008q0-.521,0-.559a7.209,7.209,0,0,0-7.079-6.592h-.464a.954.954,0,0,0,0,1.908h.448a5.31,5.31,0,0,1,5.186,4.749c0,.036,0,.2,0,.5Zm-4.972-17.931a1.565,1.565,0,0,1,1.565,1.564v4.272a1.564,1.564,0,1,1-3.129,0v-4.272A1.564,1.564,0,0,1,352.145,229.755Zm11.322,3.554a1.561,1.561,0,0,1,.461,2.158l0,0-2.334,3.586a1.563,1.563,0,0,1-2.625-1.7v0l2.333-3.586A1.567,1.567,0,0,1,363.467,233.31ZM370,242.161a1.559,1.559,0,0,1-.753,2.072h0l-3.889,1.809a1.561,1.561,0,0,1-1.324-2.828h0l3.89-1.809A1.564,1.564,0,0,1,370,242.161Zm-35.706,0a1.564,1.564,0,0,1,2.077-.756l3.889,1.809a1.56,1.56,0,0,1,.756,2.072v0a1.564,1.564,0,0,1-2.077.756l-3.889-1.809a1.559,1.559,0,0,1-.756-2.072v0Zm6.531-8.851a1.566,1.566,0,0,1,2.165.46l2.334,3.586a1.56,1.56,0,0,1-.457,2.158l0,0a1.566,1.566,0,0,1-2.164-.46l-2.333-3.586a1.56,1.56,0,0,1,.456-2.159h0Z",
    transform: "translate(-0.181 -0.009)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomenEmergency);
export default __webpack_public_path__ + "static/media/womenEmergency.9ca1badafbbe74095e79b2e94e993833.svg";
export { ForwardRef as ReactComponent };